import {
  EntryMode,
  entryModes,
  ExitMode,
  exitModes,
  FolderItem,
  ManualVariable,
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, jsonAbstract } from "@/src/utils/utils";

export async function getManualVariableValue({
  variableName,
  item,
}: {
  variableName: ManualVariable;
  item: FolderItem | null | undefined;
}) {
  let value = jsonAbstract(variableName) as ManualVariable;
  let hospitalisation = await apiFetch("hospitalisations", "loadOne", {
    id: getItemId(item),
  });

  if (value == "BED_NAME") {
    let bed = await apiFetch("beds", "loadOne", {
      id: getItemId(hospitalisation?.bed),
    });
    return bed?.name || "";
  }

  if (value == "SERVICE_NAME") {
    let bed = await apiFetch("beds", "loadOne", {
      id: getItemId(item),
    });
    return bed?.unit?.service?.name || "";
  }

  if (value == "EXIT_MODE")
    return (
      exitModes[hospitalisation?.discharge?.exitMode as ExitMode]?.name || ""
    );
  if (value == "ENTRY_MODE")
    return entryModes[hospitalisation?.entryMode as EntryMode]?.name || "";
  if (value == "EXIT_DATE") return hospitalisation?.discharge?.exitDate || "";
  if (value == "ENTRY_DATE") return hospitalisation?._date || "";

  if (value == "ADMISSION_NUMBER")
    return hospitalisation?.admissionNumber || "";

  if (value == "PATIENT_DIAGNOSTICS")
    return (
      hospitalisation?.diagnostics
        ?.map((d) => d?.reference?.name || "")
        .filter((a) => a)
        .join(", ") || ""
    );
}
